import './headerType.css';
import React, { useContext } from 'react';
import { PokedexContext } from '../../Data/Context/pokemonData';
import Span from '../span/span';
import { LanguageContext } from '../../Data/Context/languageContext';

const HeaderType = () => {
    const { pokemonData } = useContext(PokedexContext);
    const { t } = useContext(LanguageContext);

    return (
        <div className={`row builder-header rounded-top header-type-color-${pokemonData.types.type_1}`}>
            <div className="col header-type-pokemon-container py-3">

                <div className='d-flex flex-row align-content-center align-items-center justify-content-between'>
                    <div>
                        <Span classes={`ms-2 me-0 type-${pokemonData.types.type_1}`} type={t(pokemonData.types.type_1)}></Span>
                        {pokemonData.types.type_2 &&
                            <Span classes={`ms-2 me-0 mt-1 mt-md-0 mt-lg-1 type-${pokemonData.types.type_2}`} type={t(pokemonData.types.type_2)}></Span>
                        }
                    </div>

                    <h3 className='text-center text-uppercase fw-bold mb-0'>{pokemonData.name.pokeland}</h3>

                </div>

                {/* <div className='row'>
                    <div className='col-12 pt-2'>
                        <img loading="lazy"className="header-type-type"
                            src={pokemonData.assets.type_1}
                            alt={pokemonData.seo.type_1_alt}></img>
                        {pokemonData.types.type_2 &&
                            <img loading="lazy"className="header-type-type"
                                src={pokemonData.assets.type_2}
                                alt={pokemonData.seo.type_2_alt}></img>
                        }
                    </div>
                </div>

                <div className='col-12 mt-3 mt-sm-0 mb-5'>
                    <h3 className='text-center text-uppercase fw-bold'>{pokemonData.name.pokeland}</h3>
                </div> */}
            </div>
        </div>
    );
}
export default HeaderType;